import React from 'react';

import Container from '../components/Container';
import TableTitle from '../components/TableTitle';
import BtnFilled from '../components/BtnFilled';
import IconButton from '@mui/material/IconButton';

import { SettingsEthernet } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import EmptyPlaceholder from '../features/integrations/EmptyPlaceholder';

const ArchiveIntegrations = () => {
  const navigate = useNavigate();
  // const { isLoading } = useIntegrationsStore();

  // const columns = [
  //   {
  //     key: 'actions',
  //     title: 'Дата выполнения',
  //     // render: (value) => new Date(value?.updated_at).toLocaleString('ru-RU'),
  //   },
  //   {
  //     key: 'actions',
  //     title: 'ФИО',
  //     // render: (value) => new Date(value?.updated_at).toLocaleString('ru-RU'),
  //   },
  //   {
  //     key: 'actions',
  //     title: 'Счетчик',
  //   },
  //   {
  //     key: 'actions',
  //     title: 'Серийный номер',
  //   },
  //   {
  //     key: 'actions',
  //     title: 'Код плательщика',
  //   },
  //   {
  //     key: 'actions',
  //     title: 'Ссылка',
  //   },
  // ];

  return (
    <Container>
      {/*{isLoading ? (*/}
      {/*  <LoadingSpinner loading={true} />*/}
      {/*) : (*/}
      <div className="flex justify-between items-center flex-wrap gap-2 mb-8">
        <TableTitle title={'Архив передачи показаний'} />
        <BtnFilled btnCb={() => navigate('/integrations')} title={'Активные заявки'} className={'bg-orange-500 hover:bg-orange-600 w-fit hidden sm:block'} />
        <IconButton
          onClick={() => navigate('/integrations')}
          className="!bg-orange-500 p-1.5"
          sx={{
            display: { sm: 'none' },
          }}>
          <SettingsEthernet className={'text-white'} />
        </IconButton>
      </div>
      {/*)}*/}
      <EmptyPlaceholder text={'Архив передачи показаний пуст'} />
    </Container>
  );
};
export default ArchiveIntegrations;
